import Quill from "quill";

export class CleanTemplate {
  private static regularExp: RegExp = /\$\{(.*?)\}/g;
  private static forbiddenChars: string[] = ['}', '{',];

  public static template(quill: Quill, variables: string[]): string {
    if (!quill) return "";
    const input = quill.getText();

    const array = Array.from(input.trim().matchAll(this.regularExp),
      match => {
        return {value: match[0], nameParam: match[1].trim(),position:match.index}
      });
    if (!array) return input;
    if (variables.length) {
      const value = array?.map(item => item.nameParam)
        ?.filter(value => !variables.includes(value));
      if(value && value.length){
          value.forEach((item) => {
            const val = array.find(v => v.nameParam === item);
            if (val)
            quill.deleteText(val.position, val.value?.length, Quill.sources.SILENT);
          })
      }
    }
    return input;
  }

  static onEditorCreated(editor: Quill): void {
    const editorRoot = editor.root;
    editorRoot.addEventListener('keydown', (event: KeyboardEvent) => {
      if (this.forbiddenChars.includes( event.key)) {
        event.preventDefault();
        // event.stopPropagation();
      }
    });
  }

  static restoreStyleVariable(editor: Quill): string {
    const input = editor.getText();
    let position = 0;
    const charsForbidden= [...this.forbiddenChars, "$"];
    for (let i = 0; i < input.length; i++) {
      const char = input[i];
      if (charsForbidden.includes(char)) {
        editor.removeFormat(position, 1, Quill.sources.SILENT);
      }
      position++;
    }
    return editor.getSemanticHTML();
  }


  static checkBraceBalance(text: string): { mismatched: boolean; position?: number } {
    const regex = /\$\{|\{|\}/g;
    let balance = 0;
    let lastOpenPosition: number | undefined;
    let match;
    while ((match = regex.exec(text)) !== null) {
      const value = match[0];
      const index = match.index;

      if (value === '${') {
        balance++;
        lastOpenPosition = index;
      } else if (value === '}') {
        balance--;
        if (balance < 0) {
          return { mismatched: true, position: index };
        }
      }
    }
    return balance > 0 ? { mismatched: true, position: lastOpenPosition } : { mismatched: false };
  }

}
